<template>
    <section :class="[shit$(`w:100%;`)]" >
        <div @click="() => eventProxyEmit(data.title.handler)" :class="shit$(data.title.shit)">
            <i :class="[data.icon.href, shit$(data.icon.shit)]"></i>
            <span>{{ data.title.label }}</span>
        </div>
        <el-collapse-transition>
            <section v-show="data.show">
                <template v-for="(o, i) in data.list">
                    <div @click="() => {
                        data.handler(data, { current: data.current !== data.index + '.' + i ? data.index + '.' + i : '' }, store),
                        o.label.shit.handler(o.label.shit, { current: data.current !== data.index + '.' + i ? o.label.shit.normal : o.label.shit.active })
                        o.svg.handler(o.svg, { current: data.current !== data.index + '.' + i  ? o.svg.normal : o.svg.active, })
                    }" :class="shit$(data.item)" :key="i">
                        <svg-icon :width="o.svg.width" :height="o.svg.height" :href="o.svg.current || o.svg.common"></svg-icon>
                        <span :class="[shit$(o.label.shit.common), shit$(o.label.shit.current)]">{{ o.label.text }}</span>
                    </div>
                </template>
            </section>
        </el-collapse-transition>
    </section>
</template>

<script>
import { store } from '@/code-lab/component/robot-connect/device-manage/observable/store.js'
export default {
    props: {
        data: Object,
    },
    beforeCreate () {
        this.store = store
    },
    methods: {
        composeStr (arr = [], split = '.') {
            return arr.reduce((a, b) => a + split + b)
        },
        eventProxyEmit (fn) {
            fn.call(this, { data: { show: !this.data.show }, key: this.composeStr(['collapse', this.data.index]) })
            fn.call(this, { data: { href: this.data.show ? 'el-icon-caret-top' : 'el-icon-caret-bottom' }, key: this.composeStr(['collapse', this.data.index, 'icon']) })
        },
    },
}
</script>
